/** Civil dates are not timestamps: rearrange the date without timezone conversion. */
export function contractPlanDate(value: string | null | undefined): string {
  if (!value) return "Sin fecha";
  return value.replace(/^(\d{4})-(\d{2})-(\d{2})$/, "$3/$2/$1");
}

export function contractPlanPercentage(value: string | number): string {
  const number = Number(value);
  return Number.isFinite(number)
    ? `${number.toLocaleString("es-ES", { maximumFractionDigits: 2 })}%`
    : String(value);
}

/** Localize the known percentage warning, leaving other server warnings intact. */
export function contractPlanWarning(value: string | null | undefined): string | null | undefined {
  if (value == null) return value;
  return value.replace(
    /^Los porcentajes suman (-?\d+\.\d{2})% \(se requiere 100%\)$/,
    (_, total: string) => `Los porcentajes suman ${Number(total).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}% (se requiere 100%)`,
  );
}
